// extracted by mini-css-extract-plugin
export default {"layout":"toast_layout__O9ZET","iconWrapper":"toast_iconWrapper__vfNCH"};